document.addEventListener('DOMContentLoaded', function () {

  /* Mobile nav toggle */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var header = document.querySelector('[data-site-header]');
  if (navToggle && header) {
    navToggle.addEventListener('click', function () {
      header.classList.toggle('is-menu-open');
    });
  }

  /* Quantity steppers */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    plus && plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* Purchase option (one-time vs subscribe & save) */
  document.querySelectorAll('[data-purchase-options]').forEach(function (wrap) {
    var options = wrap.querySelectorAll('[data-purchase-option]');
    var sellingPlanInput = wrap.querySelector('[data-selling-plan-input]');
    var submitLabel = wrap.querySelector('[data-submit-label]');
    var priceEl = document.getElementById('ProductPrice');

    function updatePrice(price) {
      if (priceEl && price) priceEl.textContent = price;
    }

    function select(option) {
      options.forEach(function (o) { o.classList.remove('is-selected'); });
      option.classList.add('is-selected');
      var isSubscribe = option.getAttribute('data-type') === 'subscribe';
      var planId = option.getAttribute('data-selling-plan-id');
      if (sellingPlanInput) {
        if (isSubscribe && planId) {
          sellingPlanInput.value = planId;
          sellingPlanInput.disabled = false;
        } else {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      }
      if (submitLabel) {
        submitLabel.textContent = option.getAttribute('data-submit-text') || submitLabel.textContent;
      }
      if (!isSubscribe) {
        updatePrice(option.getAttribute('data-price'));
      } else {
        var activePill = option.querySelector('[data-frequency-pill].is-active') || option.querySelector('[data-frequency-pill]');
        if (activePill) updatePrice(activePill.getAttribute('data-price'));
      }
    }

    options.forEach(function (option) {
      option.addEventListener('click', function (e) {
        if (e.target.closest('[data-frequency-pill]')) return;
        select(option);
      });
    });

    /* Frequency pills inside the subscribe option */
    wrap.querySelectorAll('[data-frequency-pill]').forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.stopPropagation();
        var group = pill.closest('[data-purchase-option]');
        group.querySelectorAll('[data-frequency-pill]').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var planId = pill.getAttribute('data-selling-plan-id');
        if (sellingPlanInput && planId) sellingPlanInput.value = planId;
        select(group);
        updatePrice(pill.getAttribute('data-price'));
      });
    });
  });

  /* Slide-in cart notification (AJAX add to cart) */
  var cartType = document.body.getAttribute('data-cart-type');
  var productForm = document.getElementById('ProductForm');
  var notification = document.getElementById('CartNotification');
  var backdrop = document.querySelector('[data-cart-notification-backdrop]');

  function openNotification() {
    if (!notification) return;
    notification.classList.add('is-open');
    notification.setAttribute('aria-hidden', 'false');
  }
  function closeNotification() {
    if (!notification) return;
    notification.classList.remove('is-open');
    notification.setAttribute('aria-hidden', 'true');
  }
  if (notification) {
    notification.querySelectorAll('[data-cart-notification-close]').forEach(function (btn) {
      btn.addEventListener('click', closeNotification);
    });
    if (backdrop) backdrop.addEventListener('click', closeNotification);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNotification();
    });
  }

  function updateCartCount(count) {
    var badge = document.querySelector('.cart-count');
    var cartLink = document.querySelector('a[aria-label="Cart"]');
    if (count > 0) {
      if (badge) {
        badge.textContent = count;
      } else if (cartLink) {
        var span = document.createElement('span');
        span.className = 'cart-count';
        span.textContent = count;
        cartLink.appendChild(span);
      }
    } else if (badge) {
      badge.remove();
    }
  }

  if (productForm && cartType === 'notification') {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var submitBtn = productForm.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (submitBtn) submitBtn.removeAttribute('disabled');
          if (!result.ok) {
            /* Fall back to a normal submit so the user still sees Shopify's error page */
            productForm.submit();
            return;
          }
          var item = result.data;
          var body = notification.querySelector('[data-cart-notification-body]');
          if (body) {
            body.innerHTML =
              (item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || '').replace(/"/g, '&quot;') + '">' : '') +
              '<div>' +
                '<div class="cart-notification__item-title">' + item.product_title + '</div>' +
                (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-notification__item-meta">' + item.variant_title + '</div>' : '') +
                (item.selling_plan_allocation ? '<div class="cart-notification__item-meta">' + item.selling_plan_allocation.selling_plan.name + '</div>' : '') +
              '</div>';
          }
          openNotification();
          /* Refresh the cart count badge */
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { updateCartCount(cart.item_count); })
            .catch(function () {});
        })
        .catch(function () {
          if (submitBtn) submitBtn.removeAttribute('disabled');
          productForm.submit();
        });
    });
  }

  /* Slideshow
     ========================================================================== */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('[data-slideshow-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slideshow-slide]'));
    if (!track || slides.length < 1) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slideshow-dot]'));
    var prevBtn = root.querySelector('[data-slideshow-prev]');
    var nextBtn = root.querySelector('[data-slideshow-next]');
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = (parseFloat(root.getAttribute('data-autoplay-speed')) || 6) * 1000;
    var current = 0;
    var timer = null;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function startAutoplay() {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        startAutoplay();
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    show(0);
    startAutoplay();
  });

});
